// src/components/modals/DetailsModal/WordModalTabs/SeeAlsoTab.js
import React from 'react';
import { LinkIcon } from '@heroicons/react/24/outline';
import SearchResultCard from '../../../search/SearchResultCard';
import GlassyIcon from '../../../common/GlassyIcon';

const SeeAlsoTab = ({ relatedWords = [], seeAlsoIds = [], antonymIds = [], onItemClick, learnedIds }) => {
  const seeAlsoWords = relatedWords.filter((w) => seeAlsoIds.includes(w.id));

  const antonyms = relatedWords.filter((w) => antonymIds.includes(w.id));
  if (seeAlsoWords.length === 0 && antonyms.length === 0) {
    return (
      <div className="p-6 text-center py-8">
        <LinkIcon className="h-12 w-12 text-content-secondary/40 mx-auto mb-3" />
        <p className="text-content-secondary">No related words found.</p>
      </div>
    );
  }

  return (
    <div className="relative px-6 pb-6 space-y-6">
      {/* Background decor can remain */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute rounded-full backdrop-blur-sm border border-white/5"
          style={{
            background: 'linear-gradient(135deg, rgba(236, 72, 153, 0.06), rgba(59, 130, 246, 0.04))',
            width: '110px',
            height: '110px',
            top: '15%',
            right: '8%',
            boxShadow: '0 8px 32px rgba(236, 72, 153, 0.02)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
        </div>
        <div
          className="absolute rounded-full backdrop-blur-sm border border-white/5"
          style={{
            background: 'linear-gradient(45deg, rgba(34, 197, 94, 0.05), rgba(139, 92, 246, 0.03))',
            width: '85px',
            height: '85px',
            bottom: '20%',
            right: '15%',
            boxShadow: '0 8px 32px rgba(34, 197, 94, 0.01)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
        </div>
      </div>

      {/* Content */}
      <div className="relative space-y-6">
        {seeAlsoWords.length > 0 && (
          <div>
            <div className="flex items-center mb-4">
              <GlassyIcon 
                icon={LinkIcon} 
                size="sm" 
                color="blue" 
                className="mr-3" 
              />
              <h3 className="text-lg font-bold text-content-primary">See Also</h3>
            </div>
            <div className="space-y-3">
              {seeAlsoWords.map((word) => (
                <SearchResultCard key={word.id} item={word} type="words" onClick={() => onItemClick(word)} variant="light" learnedIds={learnedIds} />
              ))}
            </div>
          </div>
        )}

        {antonyms.length > 0 && (
          <div>
            <div className="flex items-center mb-4">
              <GlassyIcon 
                icon={LinkIcon} 
                size="sm" 
                color="red" 
                className="mr-3" 
              />
              <h3 className="text-lg font-bold text-content-primary">Antonyms</h3>
            </div>
            <div className="space-y-3">
              {antonyms.map((word) => (
                <SearchResultCard key={word.id} item={word} type="words" onClick={() => onItemClick(word)} variant="light" learnedIds={learnedIds} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SeeAlsoTab;
